import { produce } from 'immer';
import { type CancelState } from './CancelComponent';

export enum Navigation {
  Pause = '/cancel/pause/',
  // none of the routes here are actually used other than /pause
  PrimaryReason = '/cancel/primary-reason/',
  Winback = '/cancel/winback/',
  SecondaryReason = '/cancel/secondary-reason/',
  Confirm = '/cancel/confirm/',
  Success = '/cancel/success/',
}

export const navigationOrder: Navigation[] = [
  Navigation.Pause,
  Navigation.PrimaryReason,
  Navigation.Winback,
  Navigation.SecondaryReason,
  Navigation.Confirm,
];

export function getNext(
  value:
    | string
    | {
        cancelReasonId: number[];
        cancelReasonText: string | null;
        cancelFreeTextHeader: string | null;
      }
    | undefined,
  pathname: string,
  showWinback: boolean | undefined,
  cancelState: CancelState
) {
  if (pathname === Navigation.Pause) {
    return produce(cancelState, (draft) => {
      draft.next = Navigation.PrimaryReason;
    });
  }
  if (pathname === Navigation.PrimaryReason) {
    const primaryReasonValue =
      value && typeof value === 'object' && !Array.isArray(value)
        ? value
        : {
            cancelReasonId: null,
            cancelReasonText: null,
            cancelFreeTextHeader: null,
          };
    const { cancelReasonId, cancelReasonText, cancelFreeTextHeader } =
      primaryReasonValue;
    if (showWinback) {
      return produce(cancelState, (draft) => {
        draft.cancelReasonId = cancelReasonId?.length
          ? cancelReasonId[0]
          : null;
        draft.cancelReasonText = cancelReasonText;
        draft.cancelFreeTextHeader = cancelFreeTextHeader;
        draft.next = Navigation.Winback;
      });
    } else {
      return produce(cancelState, (draft) => {
        draft.cancelReasonId = cancelReasonId?.length
          ? cancelReasonId[0]
          : null;
        draft.cancelReasonText = cancelReasonText;
        draft.cancelFreeTextHeader = cancelFreeTextHeader;
        draft.next = Navigation.SecondaryReason;
      });
    }
  }
  if (pathname === Navigation.Winback) {
    return produce(cancelState, (draft) => {
      draft.next = Navigation.SecondaryReason;
    });
  }
  if (pathname === Navigation.SecondaryReason) {
    return produce(cancelState, (draft) => {
      const secondaryReasonValue =
        value && typeof value === 'object' && !Array.isArray(value)
          ? value
          : {
              cancelReasonId: null,
              cancelReasonText: null,
              cancelFreeTextHeader: null,
            };
      const { cancelReasonId, cancelFreeTextHeader } = secondaryReasonValue;
      draft.cancelSubreasonId = cancelReasonId?.length ? cancelReasonId : [];
      draft.next = Navigation.Confirm;
      if (cancelFreeTextHeader !== null) {
        draft.cancelFreeTextHeader = cancelFreeTextHeader;
      }
    });
  }
  if (pathname === Navigation.Confirm) {
    return produce(cancelState, (draft) => {
      const cancelFreeText = value && typeof value === 'string' ? value : null;
      draft.next = Navigation.Success;
      draft.cancelFreeText = cancelFreeText;
    });
  }
  return produce(cancelState, (draft) => {
    draft.next = null;
  });
}

export function getPrev(pathname: string, showWinback: boolean | undefined) {
  if (pathname === Navigation.PrimaryReason) {
    return Navigation.Pause;
  }
  if (pathname === Navigation.Winback) {
    return Navigation.PrimaryReason;
  }
  if (pathname === Navigation.SecondaryReason) {
    if (!showWinback) {
      return Navigation.PrimaryReason;
    }
    return Navigation.Winback;
  }
  if (pathname === Navigation.Confirm) {
    return Navigation.SecondaryReason;
  }
  return null;
}
